// カラーパレット設定ファイル
// 各パレットは8色で構成される

export const DEFAULT_COLOR_PALETTES = {
    // デフォルト（現在のテーマ）
    default: {
        name: 'デフォルト',
        colors: {
            primary: '#4285F4',      // メインカラー
            primaryDark: '#2563eb',  // プライマリ暗色
            secondary: '#357AE8',    // セカンダリカラー
            accent: '#28a745',       // アクセントカラー
            background: '#ffffff',   // 背景色
            surface: '#f8f9fa',      // サーフェス色
            text: '#333333',         // テキスト色
            textMuted: '#6c757d',    // ミュートテキスト色
            border: '#ced4da'        // ボーダー色
        }
    },

    // モダンブルー
    modernBlue: {
        name: 'モダンブルー',
        colors: {
            primary: '#2563eb',
            primaryDark: '#1d4ed8',
            secondary: '#1d4ed8',
            accent: '#06b6d4',
            background: '#ffffff',
            surface: '#f1f5f9',
            text: '#1e293b',
            textMuted: '#64748b',
            border: '#cbd5e1'
        }
    },

    // ウォームオレンジ
    warmOrange: {
        name: 'ウォームオレンジ',
        colors: {
            primary: '#ea580c',
            primaryDark: '#c2410c',
            secondary: '#c2410c',
            accent: '#f59e0b',
            background: '#ffffff',
            surface: '#fef7ed',
            text: '#1c1917',
            textMuted: '#78716c',
            border: '#d6d3d1'
        }
    },

    // フレッシュグリーン
    freshGreen: {
        name: 'フレッシュグリーン',
        colors: {
            primary: '#16a34a',
            primaryDark: '#15803d',
            secondary: '#15803d',
            accent: '#84cc16',
            background: '#ffffff',
            surface: '#f0fdf4',
            text: '#14532d',
            textMuted: '#6b7280',
            border: '#d1d5db'
        }
    },

    // エレガントパープル
    elegantPurple: {
        name: 'エレガントパープル',
        colors: {
            primary: '#7c3aed',
            primaryDark: '#6d28d9',
            secondary: '#6d28d9',
            accent: '#a855f7',
            background: '#ffffff',
            surface: '#faf5ff',
            text: '#581c87',
            textMuted: '#6b7280',
            border: '#d1d5db'
        }
    },

    // ダークモード
    dark: {
        name: 'ダークモード',
        colors: {
            primary: '#60a5fa',
            primaryDark: '#3b82f6',
            secondary: '#3b82f6',
            accent: '#34d399',
            background: '#111827',
            surface: '#1f2937',
            text: '#f9fafb',
            textMuted: '#9ca3af',
            border: '#374151'
        }
    },

    // ミニマル
    minimal: {
        name: 'ミニマル',
        colors: {
            primary: '#000000',
            primaryDark: '#404040',
            secondary: '#404040',
            accent: '#666666',
            background: '#ffffff',
            surface: '#fafafa',
            text: '#000000',
            textMuted: '#666666',
            border: '#e5e5e5'
        }
    },

    // サンセット
    sunset: {
        name: 'サンセット',
        colors: {
            primary: '#f97316',
            primaryDark: '#ea580c',
            secondary: '#ea580c',
            accent: '#fbbf24',
            background: '#fffbeb',
            surface: '#fef3c7',
            text: '#92400e',
            textMuted: '#a16207',
            border: '#f3e8ff'
        }
    }
};

// カラーパレットのキー一覧を取得
export const getColorPaletteKeys = () => Object.keys(DEFAULT_COLOR_PALETTES);

// 特定のカラーパレットを取得
export const getColorPalette = (paletteKey) => {
    return DEFAULT_COLOR_PALETTES[paletteKey] || DEFAULT_COLOR_PALETTES.default;
};

// カラーパレットからCSS変数を生成
export const generateCSSVariables = (paletteKey) => {
    const palette = getColorPalette(paletteKey);
    const cssVariables = Object.entries(palette.colors)
        .map(([key, value]) => `--color-${key}: ${value};`)
        .join('\n  ');

    return `:root {\n  ${cssVariables}\n}`;
};

// カラーパレットをSCSS変数として生成
export const generateSCSSVariables = (paletteKey) => {
    const palette = getColorPalette(paletteKey);
    const scssVariables = Object.entries(palette.colors)
        .map(([key, value]) => `$color-${key}: ${value};`)
        .join('\n');

    return scssVariables;
};
